import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueLazyloadNext from 'vue-lazyload-next'
import App from '@/App.vue'
import router from '@/router'
import { initFirebase } from '@/stores/firebase'
import '@/libs/mql-addEventListener-polyFill'

initFirebase()

createApp(App)
  .use(createPinia())
  .use(VueLazyloadNext)
  .use(router)
  .mount('#app')
